module.exports = __webpack_public_path__ + "static/two-children-kissing-their-mother-on-the-cheek.04a07d14.webp";